import type { RouteRecordRaw } from 'vue-router';

export const transactionsRoutes: RouteRecordRaw[] = [
  {
    path: 'transactions',
    name: 'transactions',
    component: () => import('./pages/TransactionsListPage.vue'),
    meta: { title: 'Transactions', requiresAuth: true, permission: 'view_transactions' },
  },
  {
    path: 'transactions/new',
    name: 'transactions.create',
    component: () => import('./pages/TransactionFormPage.vue'),
    meta: { title: 'New transaction', requiresAuth: true, permission: 'create_transactions' },
  },
];
